import { callAuthorizedGraphQLEndpoint } from '../../../../../Module/graphQL'

const getUsersWithAvailability = ({
  week,
  cityId,
  missionIdToShowDistance,
}) => {
  const query = `
query getUserMissionAvailability($userIds: [ID!],$cityIds: [ID!],$week: Int!, $missionIdToShowDistance: ID) {
    getUserMissionAvailability(userIds: $userIds,cityIds: $cityIds, week: $week, missionIdToShowDistance: $missionIdToShowDistance) {
        name
        userId
        error
        documentType
        distance
        isNoticePeriod
        accessibilityWithMissions { 
            week
            year
            userMissionInThisWeek
            maxMissionPerWeek
            availableMissions
            availableExtraMissions
            extraMissionUsed
            accessibility {
                MONDAY { 
                    MORNING {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    LUNCH {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    AFTERNOON {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                }
                TUESDAY { 
                    MORNING {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    LUNCH {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    AFTERNOON {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                }
                WEDNESDAY { 
                    MORNING {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    LUNCH {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    AFTERNOON {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                }
                THURSDAY { 
                    MORNING {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    LUNCH {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    AFTERNOON {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                }
                FRIDAY { 
                    MORNING {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    LUNCH {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    AFTERNOON {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                }
                SATURDAY { 
                    MORNING {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    LUNCH {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                    AFTERNOON {
                        isActive
                        mission {id, dateTime, isNotShown}
                        hasAvailability
                        isTimeOff
                        isExpiredContract
                    }
                }
            }
        }
    }
}
  `
  const params = { week, cityIds: [cityId], missionIdToShowDistance }
  return callAuthorizedGraphQLEndpoint(query, params)
}

export { getUsersWithAvailability }
